import styled from 'styled-components';

export const Table = styled.table`
  overflow: scroll;
  height: 80%;
  min-width: 100%;
`;

export const Thead = styled.thead`
  tr {
    border: none !important;
  }
`;

export const Tr = styled.tr`
  border-top: 1px solid lightgrey;
  &:first-child {
    border-top: 2px solid lightgrey;
  }
  &:last-child {
    border-bottom: 2px solid lightgrey;
  }
  background: ${props => (props.idx % 2 === 0 ? '#efefef' : 'none')};
`;

export const Th = styled.th`
  min-width: ${props => props.customWidth};
  color: black;
  font-weight: normal;
  padding: 5px;
  border-top: 0;
  text-align: center;
`;

export const Td = styled.td`
  padding: 10px;
  color: black;
  border-right: 1px solid lightgrey;
  text-align: center;
`;
//${''/* max-height: ${props => props.showMore ? '50px' : 'none'};
//cursor: ${props => props.showMore ? '50px' : 'none'}; */}



// WEBPACK FOOTER //
// ./src/components/table/Table.js